import { Swords, Target, Rocket } from "lucide-react";
import ScrollReveal from "./ScrollReveal";

const steps = [
  {
    number: "01",
    icon: Swords,
    title: "The Week's Match-ups",
    description:
      "Every race week, a fresh set of head-to-head driver battles drops. Verstappen vs Norris. Russell vs Leclerc. Gasly vs Ocon. Eleven matchups across the grid — each one handpicked to spark debate.",
  },
  {
    number: "02",
    icon: Target,
    title: "Pick Your Winners",
    description:
      "Simply choose who beats who across the grid and predict pole.",
  },
  {
    number: "03",
    icon: Rocket,
    title: "SEND IT Before Qualy",
    description:
      "Lock in your tips before qualifying starts. No ifs, buts, or maybes. Results published after the race.",
  },
];

export default function HowItWorksSection() {
  return (
    <section className="relative px-6 py-24 sm:py-32">
      <div className="mx-auto max-w-6xl">
        <ScrollReveal>
          <p className="mb-3 text-center text-xs font-semibold uppercase tracking-[0.25em] text-primary">
            How It Works
          </p>
          <h2 className="mb-16 text-center text-3xl font-black tracking-tight sm:text-4xl">
            Simply Lovely.
          </h2>
        </ScrollReveal>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          {steps.map((step, i) => (
            <ScrollReveal key={i} delay={i * 150} className="h-full">
              <div className="flex h-full flex-col rounded-2xl bg-[hsl(var(--foreground)/0.03)] p-6 sm:p-8">
                <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10">
                  <step.icon className="h-6 w-6 text-primary" />
                </div>
                <span className="mb-2 block text-xs font-bold uppercase tracking-widest text-primary">
                  {step.number}
                </span>
                <h3 className="mb-3 text-lg font-bold sm:text-xl">
                  {step.title}
                </h3>
                <p className="text-sm leading-relaxed text-muted-foreground sm:text-base">
                  {step.description}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
